module.exports = __webpack_public_path__ + "img/hero_image.98e3ce3.svg";